import { useEffect } from 'react';

import { OrderType } from '../../../../core/types/route.types';
import { urlUtils } from '../../../../utils/urlUtils';

export const useDeliveryLocationRedirect = (
  type: OrderType,
  isDeliveryLocationsSuccess: boolean,
  isDeliveryLocation: boolean,
  vrId: number,
): void => {
  useEffect(() => {
    const isDeliveryLocationInvalid =
      type === OrderType.DELIVERY &&
      isDeliveryLocationsSuccess &&
      !isDeliveryLocation;

    if (isDeliveryLocationInvalid && vrId) {
      urlUtils.navigateToHash(`/restaurant/${vrId}/delivery`);
    }
  }, [isDeliveryLocation, isDeliveryLocationsSuccess, vrId, type]);
};
